import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlBundle } from '../../../models/urlBundle';
import { UrlProviderService } from '../../../services/url.provider';

@Component({
  selector: 'eid-ec-already-registered',
  templateUrl: './ec-already-registered.component.html',
  styleUrls: ['./ec-already-registered.component.scss']
})
export class EasyCryptoAlreadyRegisteredComponent {
  public urlBundle$: Observable<UrlBundle>;

  constructor(private urlProviderService: UrlProviderService) {
    this.urlBundle$ = this.urlProviderService.urlBundle$;
  }
}
